import { createContext } from "react";

import { Contract, getDefaultProvider } from "ethers";
import CopyCats from "../artifacts/contracts/CopyCats.sol/CopyCats.json";
import LicenseToken from "../artifacts/contracts/LicenseToken.sol/LicenseToken.json";
import MarketplaceContract from "../artifacts/contracts/Marketplace.sol/Marketplace.json";

export const ContractContext = createContext();

export const ContractContextProvider = ({ children }) => {
  const contractAddr = {
    // copyrights: "0xA1fB2b3FD6A1e3562be6eaF0449a27c9584EeFA5",
    // copyrights: "0x4b43Ef52e5f25950bC05f95ff80C4C64a12465A2",
    copyrights: "0x4B506DF7ACc37de56e53d0E39EdAaf8154684a64",
    licenses: "0xf44103747956467578d0C0F5f35D75a47E9bd2e3",
    // marketplace: "0x97981db0feA331a16B116C02C14D27f7917A91e9",
    marketplace: "0xFdCAf11a2A6A59B47657E22fA1f55F1b6fd1e3d4",
  };

  const provider = getDefaultProvider("goerli");

  const copyrightsContract = new Contract(
    contractAddr.copyrights,
    CopyCats.abi,
    provider
  );

  const licensesContract = new Contract(
    contractAddr.licenses,
    LicenseToken.abi,
    provider
  );

  const marketplaceContract = new Contract(
    contractAddr.marketplace,
    MarketplaceContract.abi,
    provider
  );

  return (
    <ContractContext.Provider
      value={{
        contractAddr,
        copyrightsContract,
        licensesContract,
        marketplaceContract,
      }}
    >
      {children}
    </ContractContext.Provider>
  );
};
